var React = require('react');

function ArrowSimple (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11 1.43055e-07L15.5 0L4.5 18L15.5 36H11L-9.53674e-07 18L11 1.43055e-07Z"}));
}

ArrowSimple.defaultProps = {"width":"16","height":"36","viewBox":"0 0 16 36"};

module.exports = ArrowSimple;

ArrowSimple.default = ArrowSimple;
